export interface SerpSocialLink {
  id: string;
  label: string;
  url: string;
  icon: string;
}

export const SERP_SUBSCRIBE_SOCIAL_LINKS: readonly SerpSocialLink[] = [
  {
    id: 'vk',
    label: 'ВКонтакте',
    url: 'https://vk.ru/travelata',
    icon: 'illustrations/vkontakte-circle.svg',
  },
  {
    id: 'max',
    label: 'MAX',
    url: 'https://max.ru/id721602291640_bot?startapp=MX7c91a0197115ac75',
    icon: 'illustrations/max-circle.svg',
  },
  {
    id: 'telegram',
    label: 'Telegram',
    url: 'https://t.me/travelata',
    icon: 'illustrations/telegram-circle.svg',
  },
];
